import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import React from "react";

import Logo from "@assets/img/logo.svg";
import { Link } from "react-router-dom";

const styles = makeStyles({
  frame: {
    display: "flex",
    boxShadow:
      "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
    background: "linear-gradient(180deg, #6a3486 0%, #4d2960 100%)",
    borderRadius: "5px",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  frameForm: {
    boxSizing: "border-box",
    padding: "32px",
    background: "#FFFFFF",
    "@media all and (min-width: 768px)": {
      padding: "50px 40px",
    },
  },
  frameBanner: {
    display: "none",
    "@media all and (min-width: 992px)": {
      display: "grid",
      justifyContent: "space-around",
      width: "320px",
      padding: "50px 40px",
    },
  },
  frameBannerImage: {
    display: "block",
    width: "240px",
  },
  frameText: {
    fontSize: "16px",
    fontWeight: "lighter",
    letterSpacing: "0.5px",
    lineHeight: "24px",
    color: "#ffffff",
    alignSelf: "center",
  },
  moreInfoText: {
    fontSize: "18px",
    color: "#ffffff",
    textDecoration: "none",
    alignSelf: "flex-end",
  },
});

const banner = {
  NONE: "none",
  LEFT: "left",
  RIGHT: "right",
};

function AuthFrameBanner() {
  const classes = styles();
  const location = useLocation();

  return (
    <div className={classes.frameBanner}>
      <img
        className={classes.frameBannerImage}
        src={Logo}
        alt="Torpedo Empresa"
      />
      {location.pathname === "/login" && (
        <>
          <Typography className={classes.frameText} variant="body2">
            A comunicação de sua empresa muito mais ágil, fácil e confiável.
          </Typography>
          <Link to="/login/saiba-mais" className={classes.moreInfoText}>
            <Typography className={classes.moreInfoText} variant="h4">
              Saiba Mais
            </Typography>
          </Link>
        </>
      )}
    </div>
  );
}

function AuthFrame(props) {
  const classes = styles();
  return (
    <div className={classes.frame}>
      {props.banner === banner.LEFT && <AuthFrameBanner />}
      <div className={classes.frameForm}>{props.children}</div>
      {props.banner === banner.RIGHT && <AuthFrameBanner />}
    </div>
  );
}

AuthFrame.propTypes = {
  children: PropTypes.node.isRequired,
  banner: PropTypes.string,
};

AuthFrame.defaultProps = {
  children: null,
  banner: banner.NONE,
};

export default AuthFrame;
